export default {
	lang:'ru',
	download:{
		"download01": 'Windows',
		"download02":"Мак",
		"download02":"Мак",
		"download03":"iOS",
		"download04":"Андроид",
		"download05":"Загрузить сейчас",
		"download":"скачать",
		"download2":"Мобильный",
		"download3":"Отсканируйте QR-код, чтобы загрузить iOS/Android",
		"download4":"QR-код",
		"download5":"Окна",
		"download6":"Поддержка 64-битной версии Windows 10 и выше",
		"download7":"macOS",
		"download8":"Поддерживает MacOS 10.14 и выше",
		"download9":"Магазин приложений",
		"download10":"Поддерживает MacOS 10.14 и выше",
		"download11":"Андроид",
		"download12":"Поддержка Android 10.14 и выше",
	},
	home:{
		"home":"первая страница",
		"XiaobeiBigModel":"Маленькая модель",
		"AIcapability":"Возможности ИИ",
		"Solution":"Решение",
		"ProductCenter":"Центр продуктов",
		"MediaCenter":"Медиацентр",
		"AboutUs":"о нас",
		"Login/Regis":"Войти/Зарегистрироваться",
		"home1":"Основные компетенции",
		"home2":"Горячая линия обслуживания клиентов",
		"home3":"Контактный номер",
		"home14":"Расширение возможностей ИИ с использованием интеллектуального оборудования в качестве носителя обеспечивает полнофункциональный набор возможностей и услуг.",
		"home15":"Алгоритм «Пила»",
		"home16":"распознавание OCR",
		"home17":"ИИ-интеллект",
		"home18":"Распознавание речи",
		"home19":"Авторитетный словарь",
		"home20":"Перевод текста",
		"home21":"Перевод фотографий",
		"home22":"Общие вопросы и ответы",
		"home23":"Видеокурсы",
		"home24":"Большая модель Xiaobei AI",
		"home25":"Технология является основной производительной силой",
		"home26":"Технический персонал",
		"home27":"Инвестиции в НИОКР",
		"home28":"Количество патентов",
		"home29":"(В процентах)",
		"home30":"(100 миллионов юаней)",
		"home31":"(элемент)",
		"home32":"Решение",
		"home33":"Компания BeiBo, удовлетворяя потребности в применении в различных сценариях, таких как офисы, учебные заведения и автомобильные боксы, предоставляет клиентам комплексные решения, основанные на собственных возможностях НИОКР и концепциях обслуживания.",
		"home34":"Связанные решения",
		"home35":"Сопутствующие возможности продукта",
		"home36":"Полный спектр услуг",
		"home37":"Расширение возможностей ИИ с использованием интеллектуального оборудования в качестве носителя обеспечивает полнофункциональный набор возможностей и услуг.",
		"home38":"Исследования и разработки",
		"home39":"Производство",
		"home40":"Управление качеством",
		"home41":"Послепродажная поддержка",
		"home42":"Профессиональная команда разработчиков программного и аппаратного обеспечения с многолетним опытом исследований и разработок в области оптического распознавания символов (OCR), распознавания речи, перевода, искусственного интеллекта и взаимодействия человека с компьютером.",
		"home43":"Завод-источник, стабильная цепочка поставок, строгий интеллектуальный процесс производства",
		"home44":"Инспекторы по качеству проверяют каждый этап и внедряют систему менеджмента ISO9001",
		"home45":"Создавайте профессиональные группы послепродажной поддержки в стране и за рубежом, чтобы обеспечивать своевременное реагирование, целенаправленные решения и индивидуальное обслуживание.",
		"home46":"Сертификация",
		"home47":"Более 100 отечественных и зарубежных патентов",
		"home48":"Новости",
		"home49":"Узнайте о наших последних новостях",
		"home50":"проверьте детали",
		"home51":"Партнеры",
		"home52":"Сосредоточьтесь на рынке оборудования для искусственного интеллекта и предоставляйте профессиональные услуги OEM/0DM.",
		"home53":"Консультации по сотрудничеству",
		"home54":"Умный офис",
		"home55":"Умное образование",
		"home56":"Умная автомобильная коробка",
		"home57":"Распознавание речи",
		"home58":"Алгоритм «Пила»",
		"home59":"распознавание OCR",
		"home60":"Синтез речи",
		"home61":"Перевод текста",
		"home62":"Перевод изображений",
		"home63":"Голосовой перевод",
		"home64":"Обработка естественного языка",
		"home571":"распознавание OCR",
		"home581":"Распознавание речи ",
		"home591":"Голосовой перевод",
		"home601":"Синтез речи",
		"home611":"Авторитетный словарь",
		"home621":"Общие курсы",
		"home631":"Общие вопросы и ответы",
		"home641":"Обработка естественного языка",
		"home572":"Распознавание речи",
		"home582":"Синтез речи ",
		"home592":"Голосовой перевод",
		"home602":"Обработка естественного языка",
		"home603":"Больше не надо",
	},
	consult:{
		"tilte":"Мы искренне предоставим Вам полный спектр услуг по деловому сотрудничеству.",
		"subtilte":"Пожалуйста, оставьте свои контактные данные, и мы свяжемся с вами как можно скорее.",
		"name":"Пожалуйста, введите ваше имя",
		"phone":"Пожалуйста, введите ваш номер телефона",
		"mailbox":"Пожалуйста, введите ваш адрес электронной почты",
		"mailboxerr":"Ошибка формата электронной почты",
		"company":"Пожалуйста, введите название вашей компании",
		"desc":"Пожалуйста, введите ваши требования",
		"but":"Подтвердите отправку",
		"region":"Китай",
		"select":"Пожалуйста, выберите",
		"submitSuccess":"Отправить успешно",
		"submitError":"Отправка не удалась",
	},
	ProDetails:{
		"ProDetails1":"Процесс настройки",
		"ProDetails2":"Сосредоточьтесь на рынке оборудования для искусственного интеллекта и предоставляйте профессиональные услуги OEM/0DM.",
	},
	aiCapacity:{
		"aiMode1":"Возможности ИИ",
		"aiMode2":"Опираясь на такие технологии, как большие данные, графы знаний, машинное обучение и лингвистика, мы продолжаем внедрять инновации и сосредотачиваться на исследовании основных технологий ИИ и внедрении интеллектуальных аппаратных приложений.",
		"aiMode3":"Консультации по сотрудничеству",
		"aiMode4":"Основные компетенции",
		"aiMode5":"Расширение возможностей ИИ с использованием интеллектуального оборудования в качестве носителя обеспечивает полнофункциональный набор возможностей и услуг.",
		"aiMode6":"Алгоритм «Пила»",
		"aiMode7":"Объединяйте небольшие фрагментированные изображения в большие изображения для распознавания, поддерживая более 50 языков.",
		"aiMode8":"распознавание OCR",
		"aiMode9":"Извлекайте текст с помощью технологий обработки изображений и распознавания образов. Поддержка более 50 языков.",
		"aiMode10":"Распознавание речи",
		"aiMode11":"Точно распознаёт длинные и короткие аудиозаписи в текст. Поддерживает более 130 языков.",
		"aiMode12":"Синтез речи",
		"aiMode13":"Переводите текст в естественный и плавный человеческий голос. Поддержка более 130 языков.",
		"aiMode14":"Перевод текста",
		"aiMode15":"Перевод текста с целевого языка на указанный. Поддерживает более 130 языков.",
		"aiMode16":"Перевод изображений",
		"aiMode17":"Распознавание и перевод текста на изображениях. Поддерживает более 130 языков.",
		"aiMode18":"Голосовой перевод",
		"aiMode19":"Точно распознаёт и переводит длинные и короткие аудио. Поддерживает более 130 языков.",
		"aiMode20":"Обработка естественного языка",
		"aiMode21":"Реализовать вопросно-ответные, диалоговые и другие приложения на основе больших данных, знаний и понимания языковых технологий.",
		"aiMode22":"Авторитет словаря",
		"aiMode23":"Тесно сотрудничать с авторитетными учреждениями, чтобы предоставлять подлинные словари, такие как Оксфордский, Лонгмановский и словари различных языков меньшинств.",
		"aiMode24":"Видеокурсы",
		"aiMode25":"Полноценные видеокурсы, учебники обновляются одновременно, подходят для предварительного просмотра и изучения",
		"aiMode26":"Общие вопросы и ответы",
		"aiMode27":"Отвечайте на вопросы и интерпретируйте вопросы по всем предметам, учитесь по аналогии и повышайте эффективность обучения.",
		"aiMode28":"Большая модель Xiaobei AI",
		"aiMode29":"Мультимодальное взаимодействие",
		"aiMode30":"Мультимодальное взаимодействие текста, голоса и видео",
		"aiMode31":"Способность кодировать",
		"aiMode32":"Генерация кода, интерпретация, отладка, тестирование",
		"aiMode33":"Генерация текста",
		"aiMode34":"Составление, маркетинг, генерация пресс-релизов и т. д.",
		"aiMode35":"Общая практика",
		"aiMode36":"Постановка вопросов и решение проблем по всем предметам",
		"aiMode37":"Понимание языка",
		"aiMode38":"Извлечение аннотаций, проверка грамматики, анализ тональности",
		"aiMode39":"Мелочи",
		"aiMode40":"Знание жизни, работы, медицины и истории",
		"aiMode41":"Логическое рассуждение",
		"aiMode42":"Мышление, наука, рассуждения здравого смысла",
		"aiMode43":"Многоязычный",
		"aiMode44":"Поддерживает взаимодействие более чем на 100 языках",
		"aiMode45":"Технические преимущества",
		"aiMode46":"200 миллионов точных корпусов",
		"aiMode47":"Широко используется в умных офисах, умном образовании, умных автомобильных коробках.",
		"aiMode48":"Глобальные совместные технологии",
		"aiMode49":"Сверхнизкая задержка, безопасность и стабильность, интеллектуальное планирование, стабильное соединение",
		"aiMode50":"Система шифрования безопасности",
		"aiMode51":"Ведущая в мире четырехмерная система шифрования данных на уровне облачного канала, шифрование полного процесса",
	},
	aiMode:{
		"aiMode1":"Возможности ИИ",
		"aiMode2":"Опираясь на такие технологии, как большие данные, графы знаний, машинное обучение и лингвистика, мы продолжаем внедрять инновации и сосредотачиваться на исследовании основных технологий ИИ и внедрении интеллектуальных аппаратных приложений.",
		"aiMode3":"Консультации по сотрудничеству",
		"aiMode4":"Основные компетенции",
		"aiMode5":"Расширение возможностей ИИ с использованием интеллектуального оборудования в качестве носителя обеспечивает полнофункциональный набор возможностей и услуг.",
		"aiMode6":"Алгоритм «Пила»",
		"aiMode7":"Объединяйте небольшие фрагментированные изображения в большие изображения для распознавания, поддерживая более 50 языков.",
		"aiMode8":"распознавание OCR",
		"aiMode9":"Извлекайте текст с помощью технологий обработки изображений и распознавания образов. Поддержка более 50 языков.",
		"aiMode10":"Распознавание речи",
		"aiMode11":"Точно распознаёт длинные и короткие аудиозаписи в текст. Поддерживает более 130 языков.",
		"aiMode12":"Синтез речи",
		"aiMode13":"Переводите текст в естественный и плавный человеческий голос. Поддержка более 130 языков.",
		"aiMode14":"Перевод текста",
		"aiMode15":"Перевод текста с целевого языка на указанный. Поддерживает более 130 языков.",
		"aiMode16":"Перевод изображений",
		"aiMode17":"Распознавание и перевод текста на изображениях. Поддерживает более 130 языков.",
		"aiMode18":"Голосовой перевод",
		"aiMode19":"Точно распознаёт и переводит длинные и короткие аудио. Поддерживает более 130 языков.",
		"aiMode20":"Обработка естественного языка",
		"aiMode21":"На основе больших данных, знаний и языковых технологий могут быть реализованы такие приложения, как вопросы и ответы, а также диалог.",
		"aiMode22":"Авторитет словаря",
		"aiMode23":"Тесно сотрудничать с авторитетными учреждениями, чтобы предоставлять подлинные словари, такие как Оксфордский, Лонгмановский и словари различных языков меньшинств.",
		"aiMode24":"Видеокурсы",
		"aiMode25":"Полноценные видеокурсы, учебники обновляются одновременно, подходят для предварительного просмотра и изучения",
		"aiMode26":"Общие вопросы и ответы",
		"aiMode27":"Отвечайте на вопросы и интерпретируйте вопросы по всем предметам, учитесь по аналогии и повышайте эффективность обучения.",
		"aiMode28":"Большая модель Xiaobei AI",
		"aiMode29":"Мультимодальное взаимодействие",
		"aiMode30":"Мультимодальное взаимодействие текста, голоса и видео",
		"aiMode31":"Способность кодировать",
		"aiMode32":"Генерация кода, интерпретация, отладка, тестирование",
		"aiMode33":"Генерация текста",
		"aiMode34":"Составление эссе, маркетинговых материалов, пресс-релизов и т. д.",
		"aiMode35":"Общая практика",
		"aiMode36":"Постановка вопросов и решение проблем по всем предметам",
		"aiMode37":"Понимание языка",
		"aiMode38":"Извлечение аннотаций, проверка грамматики, анализ тональности",
		"aiMode39":"Мелочи",
		"aiMode40":"Знание жизни, работы, медицины и истории",
	},
	Product:{
		"Product1":"Центр продуктов",
		"Product2":"Офисные, образовательные и автомобильные интеллектуальные продукты, поддержка заказа и настройки функций",
		"Product3":"Консультации по сотрудничеству",
	},
	medium:{
		"medium1":"Медиацентр",
		"medium2":"Последние новости BeiBo смотрите здесь.",
		"medium3":"Консультации по сотрудничеству",
	},
	about:{
		"about1":"Узнайте больше о BeiBo",
		"about2":"Поставщик интеллектуальных аппаратных решений для офисов, образовательных учреждений, автомобильных боксов и т. д.",
		"about3":"Консультации по сотрудничеству",
		"about4":"Профиль компании",
		"about5":"Сертификация",
		"about6":"Более 100 отечественных и зарубежных патентов",
		"about7":"Shenzhen Beibo Intelligent Technology Co., Ltd.",
		"about8":"Компания BeiBo Intelligent, основанная в 2015 году и базирующаяся в Шэньчжэне, центре «умного производства» Китая, является национальным высокотехнологичным предприятием, а также специализированным и инновационным предприятием с дальновидным видением и инновационным духом.",
		"about9":"Компания специализируется на вертикальном сегменте голосового управления с использованием искусственного интеллекта и обладает мощными возможностями для исследований и разработок в области программного и аппаратного обеспечения на базе искусственного интеллекта. Компания расширяет возможности аппаратного обеспечения с использованием искусственного интеллекта, экспортируя такие технологии, как голосовое управление с использованием искусственного интеллекта, перевод с использованием искусственного интеллекта, оптическое распознавание символов (OCR) с использованием искусственного интеллекта, взаимодействие человека с транспортным средством с использованием искусственного интеллекта и облачные технологии искусственного интеллекта. Компания разрабатывает собственную модель голосового управления с использованием искусственного интеллекта, интегрирует новейшие мультимодальные и комбинированные технологии искусственного интеллекта (AIGC) и предоставляет комплексные решения в области голосовых технологий с использованием искусственного интеллекта для клиентов из различных сфер, основанные на исследованиях и разработках, разработке платформ микросхем и аппаратных решений. В сфере образования, государственного управления, предприятий и военной сферы компания предлагает продуманные отраслевые решения; что касается потребительского рынка, то годовой объем продаж аппаратного обеспечения с использованием искусственного интеллекта, такого как переводчики, диктофоны, сканеры и автомобильные боксы с использованием искусственного интеллекта, превышает один миллион единиц. Компания имеет множество стратегических партнеров в Японии, Европе, США и других странах и регионах, помогая людям преодолевать языковые барьеры, и является ведущим мировым поставщиком решений в области голосовых технологий с использованием искусственного интеллекта.",
		"about10":"",
	},
	footer:{
		"AboutUs":"о нас",
		"CollaborativeConsulting":"Консультации по сотрудничеству",
		"Businesscooperation":"Деловое сотрудничество",
		"phone":"Пожалуйста, введите ваш номер телефона",
		"phone2":"+86 13660736734",
		"phone3":"hangou@szbbzn.com",
		"tel":"0755 27189290",
		"address":"Комната 201, здание F, промышленная зона Юаньфэнь, район Таоюань, улица Далан, район Лунхуа, Шэньчжэнь",
		"copyright":"Авторские права © Shenzhen Beibo Intelligent Technology Co., Ltd.",
		"icp":"Гуандун ICP № 2024241358-1",
		"footer2":"Добро пожаловать на регистрацию",
		"footer3":"У вас уже есть аккаунт?",
		"footer4":"Пожалуйста, войдите в систему",
	},
	login:{
		"login1":"Пароль входа",
		"login2":"вход по СМС",
		"loginTab3":"Вход по электронной почте",
		"login3":"Почта",
		"login4":"Логин Пароль",
		"login5":"Номер телефона",
		"login6":"Пожалуйста, выберите",
		"login7":"Мобильный код подтверждения",
		"login8":"Авторизоваться",
		"login9":"забыл пароль",
		"login10":"регистр",
		"login11":"Входя в систему, вы соглашаетесь",
		"login12":"Соглашение об обслуживании",
		"login13":"политика конфиденциальности",
		"login14":"Получать",
		"login15":"Китай",
		"login16":"Пожалуйста, введите номер вашего счета",
		"login17":"Пожалуйста, введите ваш пароль",
		"login18":"Вход успешный!",
		"login19":"Пожалуйста, введите проверочный код!",
		"login20":"Отправлено успешно!",
		"login21":"и",
		"login22":"облачный диск диктофона",
		"login23":"Мое письмо",
		"login24":"Мой разговор",
		"login25":"Безопасность аккаунта",
		"login26":"Выйти",
		"login27":"Получить пароль по электронной почте",
		"login28":"Почта",
		"login29":"Код подтверждения электронной почты",
		"login30":"Установите пароль для входа (6-16 символов)",
		"login31":"Введите пароль еще раз.",
		"login32":"представлять на рассмотрение",
		"login33":"Вернуться к входу",
		"login34":"Модификация выполнена успешно!",
	},
	register:{
		"register1":"Номер телефона",
		"register2":"Пожалуйста, введите ваш номер телефона",
		"register3":"Пожалуйста, выберите",
		"register4":"Мобильный код подтверждения",
		"register5":"Установить пароль",
		"register6":"Пожалуйста, введите проверочный код",
		"register7":"6-16 символов",
		"register8":"Подтверждение пароля",
		"register9":"Почта",
		"register10":"Пожалуйста, введите ваш адрес электронной почты",
		"register11":"Код подтверждения электронной почты",
		"register12":"Пожалуйста, введите проверочный код",
		"register13":"Я прочитал и согласен",
		"register14":"Пожалуйста, прочитайте и отметьте галочкой пункт о согласии с соглашением",
		"register15":"Неверный формат номера телефона/номер телефона зарегистрирован",
		"register16":"Ошибка мобильного проверочного кода",
		"register17":"Пожалуйста, введите свой адрес электронной почты / Формат адреса электронной почты неверен",
		"register18":"Ошибка формата электронной почты",
		"register19":"Ошибка кода подтверждения электронной почты",
		"register20":"Пожалуйста, установите пароль длиной 6–16 символов.",
		"register21":"Ошибка формата пароля",
		"register22":"Пароли, введённые дважды, не совпадают. Введите их ещё раз.",
		"register23":"Пожалуйста, введите ваш пароль",
		"register24":"Регистрация прошла успешно!",
		"register25":"Ошибка проверочного кода",
	},
	recorder:{
		"recorder1":"облачный диск диктофона",
		"recorder2":"Емкость облачного пространства",
		"recorder3":"документ",
		"recorder331":"Мусорная корзина",
		"recorder332":"Очистить все",
		"recorder4":"имя",
		"recorder5":"Длительность аудио",
		"recorder6":"Размер файла",
		"recorder7":"Время создания",
		"recorder8":"работать",
		"recorder9":"Описание облачного пространства",
		"recorder10":"документ",
		"recorder11":"OCR-файл",
		"recorder12":"1. Для чего используется облачное пространство?",
		"recorder13":"После записи на диктофон вы можете загрузить аудиофайлы и расшифровку в облако. Даже если диктофона нет под рукой, вы можете получить доступ к облаку для прослушивания аудио.",
		"recorder14":"2. Как загрузить в облако?",
		"recorder15":"Перейдите в раздел [Мои файлы] на диктофоне, выберите целевой файл и нажмите и удерживайте его, чтобы отобразить параметры, затем нажмите «Загрузить», чтобы загрузить файл в облачное пространство.",
		"recorder16":"3. Как просматривать/управлять файлами облачного пространства?",
		"recorder17":"Войдите на официальный сайт BeiBo, выберите «My-Recorder Cloud Disk» и просмотрите загруженные файлы. Вы можете выбрать нужный файл для загрузки, удалить и т.д. Вы можете очистить облачное хранилище, удалив файлы!",
		"recorder18":"Не транскрибировано",
		"recorder19":"Просмотреть сводку",
		"recorder20":"Спикер",
		"recorder21":"Изменить имя докладчика",
		"recorder22":"Конечно",
		"recorder23":"скачать",
		"recorder24":"Загрузить контент:",
		"recorder25":"Настройки загрузки:",
		"recorder26":"Показать спикера",
		"recorder27":"Отмена",
		"recorder28":"Обмен ссылками",
		"recorder29":"Доступ к нему получит любой, кто получит ссылку. Ссылка предназначена только для чтения и действительна в течение 7 дней.",
		"recorder30":"Копировать ссылку",
		"recorder31":"Сканировать и быстро просматривать",
		"recorder32":"Умная организация",
		"recorder33":"Различать говорящих",
		"recorder34":"Разумно различать транскрибированный текст в соответствии с ролью говорящего",
		"recorder35":"Интеллектуальная регуляризация разговорной речи",
		"recorder36":"Автоматически фильтровать модальные частицы, повторяющиеся слова и слова с паузами",
		"recorder37":"Невокальная фильтрация",
		"recorder38":"Автоматически пропускать аудио без голоса или шума во время воспроизведения",
		"recorder39":"Пожалуйста, выберите",
		"recorder40":"документ",
		"recorder41":"Аудио",
		"recorder42":"Документы + Аудио",
		"recorder43":"намекать",
		"recorder44":"Эта операция удалит файлы. Хотите продолжить?",
		"recorder441":"Эта операция удалит все файлы. Хотите продолжить?",
		"recorder45":"Конечно",
		"recorder46":"Отмена",
		"recorder47":"Успешно удалено!",
		"recorder48":"Восстановлено",
		"recorder49":"Теги пока отсутствуют",
		"recorder50":"Сохранение...",
		"recorder51":"Мусорная корзина",
	},
	personal:{
		"personal1":"Настройки учетной записи",
		"personal2":"персональная информация",
		"personal3":"аватар",
		"personal4":"Загрузить файлы",
		"personal5":"Поддержка стилей JPG, JPEG, GIF, PNG, поддержка изображений размером до 2 МБ",
		"personal6":"Псевдоним",
		"personal7":"Пожалуйста, введите свой псевдоним",
		"personal8":"пол",
		"personal9":"господа",
		"personal10":"Скучать",
		"personal11":"Конфиденциальность",
		"personal12":"День рождения",
		"personal13":"Пожалуйста, выберите дату вашего рождения",
		"personal14":"Профессия",
		"personal15":"Пожалуйста, выберите вашу профессию",
		"personal16":"Укажите, пожалуйста, вашу профессию (необязательно)",
		"personal17":"нация",
		"personal18":"Пожалуйста, выберите вашу страну",
		"personal19":"держать",
		"personal20":"персональная информация",
		"personal21":"Безопасность аккаунта",
		"personal22":"Поддерживает только изображения размером до 2 МБ.",
		"personal23":"Загрузка прошла успешно!",
		"personal24":"Модификация выполнена успешно!",
		"personal25":"Безопасность аккаунта",
		"personal26":"Логин Пароль",
		"personal27":"Исправлять",
		"personal28":"Электронная почта",
		"personal29":"заменять",
		"personal30":"Аннулирование аккаунта",
		"personal32":"Вы уверены, что хотите удалить свою учетную запись?",
		"personal33":"После выхода из системы весь контент вашей учетной записи будет удален, поэтому будьте осторожны.",
		"personal34":"Отмена",
		"personal35":"Конечно",
		"personal36":"Аутентификация",
		"personal37":"Чтобы подтвердить, что это делаете именно вы, пройдите проверку личности, отправив нам код подтверждения по электронной почте.",
		"personal38":"Почта",
		"personal39":"Проверочный код",
		"personal40":"Пожалуйста, введите проверочный код",
		"personal41":"Следующий шаг",
		"personal42":"Настройте новый почтовый ящик",
		"personal43":"Почта",
		"personal44":"Пожалуйста, введите новый адрес электронной почты",
		"personal45":"Проверочный код",
		"personal46":"Пожалуйста, введите проверочный код",
		"personal47":"Конечно",
		"personal48":"Установите новый пароль для входа",
		"personal49":"Новый пароль для входа",
		"personal50":"Пожалуйста, введите новый пароль",
		"personal51":"Подтвердите новый пароль",
		"personal52":"Пожалуйста, введите новый пароль еще раз.",
		"personal53":"Конечно",
		"personal54":"Получать",
		"personal55":"Ошибка формата электронной почты",
		"personal56":"Замена прошла успешно!",
		"personal57":"Пожалуйста, установите пароль длиной 6–16 символов.",
		"personal58":"Пароли, которые вы ввели дважды, не совпадают.",
		"personal59":"Модификация выполнена успешно!",
		"personal60":"Выход из системы успешен!",
	}
}